module.exports = __webpack_public_path__ + "img/do-not-enter.2a42e504.svg";